import { createStore } from 'vuex';
import app from './modules/app';
import common from './modules/common';
import customer from './modules/customer';
import dashborad from './modules/dashborad';
import user from './modules/user';
import base from './modules/base';
import component from './modules/component';
import dataAuth from './modules/dataAuth';
import plan from './modules/plan';
import income from './modules/income';
import competior from './modules/competior';
import payment from './modules/return';
import organization from './modules/organization';
import getters from './getters';
import quota from './modules/quota';
import performance from './modules/performance';
import home from './modules/home';
import system from './modules/system';
import budget from './modules/budget';
import flowable from './modules/flowable';
import kpi from './modules/kpi';
import fee from './modules/fee';
import custComponent from './modules/cust-component';
import cust from './modules/cust/index';
import process from './modules/process';
export default createStore({
    modules: {
        app,
        base,
        user,
        cust,
        common,
        dataAuth,
        customer,
        component,
        dashborad,
        plan,
        income,
        quota,
        competior,
        process,
        return: payment,
        organization,
        performance,
        home,
        system,
        budget,
        flowable,
        kpi,
        fee,
        custComponent
    },
    getters
});
